import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createCategoryStructure } from '../lib/util';
import './RegisterProductSelector.css';
import RegisterProductSelectorItem from './RegisterProductSelectorItem';

class RegisterProductSelector extends Component {
  state = {
    activeCategoryID: 1,
  };

  switchActiveCategoryID = (categoryID) => {
    this.setState({
      activeCategoryID: categoryID,
    });
  };

  selectProduct = (product) => {
    this.props.handleClick(product);
    this.props.toggleModal();
  };

  render() {
    const { extraClass, categories, products } = this.props;
    let structure = [];
    if (categories && products) {
      structure = createCategoryStructure({
        categories,
        products,
        assignProduct: true,
      });
    }
    return (
      <aside className={`sidebar menu ${extraClass}`}>
        <ul className="menu-list">
          {structure.map((elem, index) => (
            <RegisterProductSelectorItem
              key={`menu-item-${index}`}
              data={elem}
              level={1}
              activeCategoryID={this.state.activeCategoryID}
              categories={categories}
              switchActiveCategoryID={this.switchActiveCategoryID}
              selectProduct={this.selectProduct}
            />
          ))}
        </ul>
      </aside>
    );
  }
}

RegisterProductSelector.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.object),
  products: PropTypes.arrayOf(PropTypes.object),
  extraClass: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
};

RegisterProductSelector.defaultProps = {
  extraClass: '',
  categories: [],
  products: [],
};

export default RegisterProductSelector;



// WEBPACK FOOTER //
// ./src/components/RegisterProductSelector.js